import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { DocumentCategorySchema } from '../property/documents.schemas';

/**
 * The channel a skill change came through when it was not the operator app (IMM-1155): an operator's `adm_`
 * credential on the admin MCP. Nested, never flattened into a top-level `credentialClass`, because
 * `audit_event_search` drops rows whose top-level `credentialClass` is `backoffice-credential` as the surface's
 * own traffic — and a change to a live prompt is evidence, not noise.
 */
export const SkillChangeViaSchema = z.object({
  credentialClass: z.literal('backoffice-credential'),
  credentialId: z.uuid(),
});
export type SkillChangeVia = z.infer<typeof SkillChangeViaSchema>;

/**
 * Published on every create / edit / activate / deactivate of a managed
 * document-analysis skill (IMM-406.3). Rides the outbox to the future IMM-67
 * admin audit surface; the queryable before/after diff lives in the
 * `immo_admin.skill_changes` journal, not on the event.
 */
export const DocumentAnalysisSkillChangedPayloadSchema = z.object({
  category: DocumentCategorySchema,
  action: z.enum(['created', 'prompt_edited', 'activated', 'deactivated']),
  actor: ActorSchema,
  via: SkillChangeViaSchema.nullable().optional(),
  occurredAt: z.iso.datetime(),
});

export type DocumentAnalysisSkillChangedPayload = z.infer<typeof DocumentAnalysisSkillChangedPayloadSchema>;
